import { CheckboxField, Form, SelectField, TextInputField } from "@sainsburys-tech/luna-form";
import { Container, GridItem, GridWrapper } from "@sainsburys-tech/luna-grid";
import React, { FC, useEffect, useState } from "react";
import FamilyGroupAutoComplete from "../../SharedComponents/FamilyGroupAutoComplete";
import { FormInputLevels, FIELDS, ProductTypeOptions } from "../../../Interfaces/IFamilyGroupFormField";
import { FamilyGroupFormProps } from "../../../Types/familyGroupFormProps";
import "./familyGroupModalEdit.scss";
import ActionButton from "../../SharedComponents/ActionButton";
import { CheckNotNullAndEmptyAndUndefined } from "../../../helpers/StringHelpersMethods";
import { useSelector } from "react-redux";

const FamilyGroupForm: FC<FamilyGroupFormProps> = (props) => {
  const payload = useSelector((state: any) => state.popupReducer);
  const [productTypeDataDisabledState, setProductTypeDataDisabledState] = useState<boolean>();
  const [isFormDirty, setIsFormDirty] = useState<boolean | undefined>(
    props.dirty || true
  );
  const isInitialState = JSON.stringify(payload?.data?.editPayload?.values) === JSON.stringify(props.values);

  useEffect(() => {
    if (!CheckNotNullAndEmptyAndUndefined(props.values.ProductType)) {
      //props.values.ProductType = ProductTypeOptions[0].value
    }

    if (CheckNotNullAndEmptyAndUndefined(props.values.FamilyGroup) 
    && CheckNotNullAndEmptyAndUndefined(props.values.ProductType)) {
      setProductTypeDataDisabledState(true)
    }
  }, [props])

  return (
    <>
      <Form className="o-form">
        <GridWrapper className="ln-u-push-bottom">
          <GridItem size={{ md: "1/4", sm: "1/3", xs: "1" }}>
            <TextInputField
              name={FIELDS.BusinessUnit}
              label={FormInputLevels.BusinessUnit}
              value={props.values.BusinessUnitDesc}
              disabled={true}
            />
          </GridItem>
          <GridItem size={{ md: "1/4", sm: "1/3", xs: "1" }}>
            <TextInputField
              name={FIELDS.SuperCategory}
              label={FormInputLevels.SuperCategory}
              value={props.values.SuperCatDesc}
              disabled={true}
            />
          </GridItem>
          <GridItem size={{ md: "1/4", sm: "1/3", xs: "1" }}>
            <TextInputField
              name={FIELDS.Category}
              label={FormInputLevels.category}
              value={props.values.CategoryDesc}
              disabled={true}
            />
          </GridItem>
          <GridItem size={{ md: "1/4", sm: "1/3", xs: "1" }}>
            <TextInputField
              name={FIELDS.SubCategory}
              label={FormInputLevels.subCategory}
              value={props.values.SubCategoryDesc}
              disabled={true}
            />
          </GridItem>
        </GridWrapper>
        <GridWrapper className="ln-u-push-bottom">
          <GridItem size={{ md: "1/4", sm: "1/3", xs: "1" }}>
            <TextInputField
              name={FIELDS.Segment}
              label={FormInputLevels.segment}
              value={props.values.SegmentDesc}
              disabled={true}
            />
          </GridItem>
          <GridItem size={{ md: "1/4", sm: "1/3", xs: "1" }}>
            <SelectField
              name={FIELDS.ProductType.name}
              label={FormInputLevels.ProductType}
              options={ProductTypeOptions}
              defaultValue={props.values.ProductType}
              error={props.errors?.ProductType}
              value={props.values.ProductType}
              onChange={props.onChange}
              onBlur={props.onBlur}
              placeholder="Please select"
              disabled={productTypeDataDisabledState}
            />
          </GridItem>
          <GridItem size={{ md: "1/4", sm: "1/3", xs: "1" }}>
            <h4 style={{ fontSize: "1.125rem" }}>Family Group</h4>
            <FamilyGroupAutoComplete
              productType={props.values.ProductType}
              className="family-Group-AutoCompleteModal"
              name="FamilyGroupNew"
              placeholder="Please select"
              testid="autocomplete-field"
              initialValue={props.values.FamilyGroup || ""}
              onSelect={(e: any) => {
                //setIsFormDirty(false);
                if (e === null || e?.value === null) {
                  e = {
                    label: props.values.FamilyGroup,
                    value: { desc: props.values.FamilyGroup },
                  };
                }
                props.onChange({ ...e, name: "FamilyGroupNew", value: e.label }, e.label, e.value?.desc);
              }}
            />
          </GridItem>
          <GridItem size={{ md: "1/4", sm: "1/3", xs: "1" }}>
            <TextInputField
              name={FIELDS.ProductCount}
              label={FormInputLevels.productCount}
              value={props.values.ProductCount}
              disabled={true}
            />
          </GridItem>
        </GridWrapper>
        <GridWrapper className="ln-u-push-bottom">
          <GridItem size={{ md: "1/4", sm: "1/3", xs: "1" }}>
            <TextInputField
              name={FIELDS.CreatedDate}
              label={FormInputLevels.createdDate}
              value={props.values.CreatedDate}
              disabled={true}
            />
          </GridItem>
          <GridItem size={{ md: "1/4", sm: "1/3", xs: "1" }}>
            <TextInputField
              name={FIELDS.UpdatedDate}
              label={FormInputLevels.updatedDate}
              value={
                props.values.UpdatedDate === "Invalid date"
                  ? "N/A"
                  : props.values.UpdatedDate
              }
              disabled={true}
            />
          </GridItem>
          <GridItem size={{ md: "1/4", sm: "1/3", xs: "1" }}>
            <TextInputField
              name={FIELDS.UpdatedBy.name}
              label={FormInputLevels.updatedBy}
              value={props.values.UpdatedBy}
              disabled={true}
            />
          </GridItem>
        </GridWrapper>
      </Form>
      <ActionButton
        onSubmit={props.onSubmit}
        onClearAll={props.onClearAll}
        onCancel={props.onCancel}
        isAddDisabled={isInitialState}
        isDirty={props.dirty}
        isEdit={props.isEdit}
        isClearButtonRequired={false}
        submitted={props.submitted}
      />
    </>
  );
};

export default FamilyGroupForm;
